import React from 'react';

import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';

const Card = styled(Box)(({ theme }) => ({
  width: '100%',
  overflow: 'hidden',
  borderRadius: '8px',
  backgroundColor: theme.palette.tofu
}));

const CardContainer = styled(Box)(({ theme }) => ({
  height: '130px',
  padding: '18px',
  [theme.breakpoints.down('md')]: {
    height: 'auto'
  }
}));

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    display: 'block'
  }
}));

const ImageContainer = styled(Grid)(({ theme }) => ({
  position: 'relative',
  order: 0,
  [theme.breakpoints.down('md')]: {
    order: -1
  }
}));

const MenuItemCardSkeleton = () => (
  <Card>
    <Grid container sx={{ height: '100%' }}>
      <Grid item {...{ lg: 8, md: 7, xs: 12 }}>
        <CardContainer>
          <StyledBox>
            <Box>
              <Skeleton variant="rectangular" width={236} height={15} />
              <Box mt="8px">
                <Skeleton variant="rectangular" width={133} height={10} />
              </Box>
            </Box>
            <Box mt="8px">
              <Skeleton variant="rectangular" width={43} height={10} />
            </Box>
          </StyledBox>
        </CardContainer>
      </Grid>
      <ImageContainer
        item
        {...{ lg: 4, md: 5, xs: 12 }}
        sx={{ height: '130px' }}
      >
        <Skeleton variant="rectangular" width="100%" height="100%" />
      </ImageContainer>
    </Grid>
  </Card>
);

export default MenuItemCardSkeleton;
